import type { AnnotationSet } from "../../api/threads/liveMessages";
import AnnotationSetView from "./AnnotationSetView";
import { useAnnotationEditor } from "./useAnnotationSetEditing";

/**
 * An annotation set its owner edits in v1's span view (W-15, F88's "edit, add and delete
 * labels"): the owner keeps the set and saves it, this view only edits it. Used by the
 * artifact form, the "Edit an item" step's view (ADR-0031 D2), and by Documents in place.
 */
export default function EditableAnnotationSet({ set, onChange }: { set: AnnotationSet; onChange: (next: AnnotationSet) => void }) {
  const editor = useAnnotationEditor(set, onChange);
  return <AnnotationSetView output={set} editing={editor ?? undefined} />;
}
